/* eslint-disable @typescript-eslint/no-unused-vars */
import DownloadResponsibilityAsTemplateButton from '../../components/DownloadResponsibilityAsImportTemplateButton';
import React, { useEffect, useState } from 'react';
import ResponsibilityFilter from './ResponsibilityFilter';
import ResponsibilityImportDialog from './responsibilityImportDialog';
import ResponsibilityStatusIcon from '../responsibility/ResponsibilityStatusIcon';
import roleRoute from '../roleRoute.config';
import { AppState } from '../../../state/configureStore';
import { downloadResponsibilityFilterAsExcel } from '../../../services/responsibilityService';
import { PageFilter } from '../../../state/app';
import { useFilter, useHasRole } from '../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Checkbox,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Publish as UploadIcon,
  HelpOutline as HelpIcon,
  AccountCircle as FaceIcon,
} from '@material-ui/icons';

import {
  clearResponsibility,
  fetchResponsibilityList,
  ResponsibilityListFilter,
  ResponsibilityState,
} from '../../../state/responsibility';
import {
  ChipList,
  PageButtonGroup,
  PageContainer,
  PageTitle,
  TableLoading,
} from '../../components';
import { ResponsibilityStatusLabel } from '../../../constants/responsibilityStatus';
import ChipListUser from '../../components/ChipListUser';
import { TablePageSize } from '../../../constants';
import { string } from 'yup';

const initialResponsibilityFilter: ResponsibilityListFilter = {
  'Status.equalsTo': '',
  'IsHighPriority.equalsTo': '',
  'Template.EqualsTo': 'MARKETING',
};

const ResponsibilityList: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isDisabled = !useHasRole(roleRoute.createResponsibility);

  const [filters, setFilters] = useFilter<ResponsibilityListFilter>(
    initialResponsibilityFilter,
  );

  const [paging, setPaging] = useState<PageFilter>({
    pageNumber: 0,
    pageSize: 10,
  });
  const {
    items: responsibilities,
    totalItems,
    loading,
  } = useSelector<AppState, ResponsibilityState>((state) => state.responsibility);

  useEffect(() => {
    dispatch(fetchResponsibilityList(filters, paging));

    return function cleanUp() {
      dispatch(clearResponsibility());
    };
  }, [dispatch, paging, filters]);

  const editResponsibility = (id: number): void => {
    history.push(`/responsibilities/form/${id}`);
  };

  const handleChangeFilter = (newFilter: ResponsibilityListFilter): void => {
    // if (newFilter['Template.EqualsTo'] !== 'MARKETING') {
    //   console.log(
    //     '==============',
    //     newFilter['Template.EqualsTo'],
    //     newFilter['Program.Name.StartsWith'],
    //   );
    //   if (newFilter['Template.EqualsTo'] != newFilter['Program.Name.StartsWith']) {
    //     console.log('====== Set Default Program Filter =======');
    //     newFilter['Program.Name.StartsWith'] = newFilter['Template.EqualsTo'];
    //   }
    // }

    setFilters(newFilter);
    setPaging({
      ...paging,
      pageNumber: 0,
    });
  };

  const handleChangePageNumber = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    setPaging({ ...paging, pageNumber: newPage });
  };

  const handleChangePageSize = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setPaging({
      ...paging,
      pageSize: +event.target.value,
      pageNumber: 0,
    });
  };

  const addNewResponsibility = (): void => {
    history.push('/responsibilities/form');
  };

  const exportExcel = () => {
    downloadResponsibilityFilterAsExcel(filters, {
      pageSize: totalItems,
    }).catch((err) => console.error(err));
  };

  const [openImportDialog, setOpenImportDialog] = useState(false);

  return (
    <PageContainer>
      <PageTitle>Responsibility</PageTitle>
      <ResponsibilityFilter
        filters={filters}
        onChangeFilter={handleChangeFilter}
        initialFilter={initialResponsibilityFilter}
      />
      <PageButtonGroup>
        {/* <Button variant="contained" onClick={exportExcel}>
          Export Excel
        </Button> */}
        <DownloadResponsibilityAsTemplateButton
          filters={filters}
          paging={paging}
          disabled={isDisabled}
        />
        <Button
          startIcon={<UploadIcon />}
          color="primary"
          variant="contained"
          onClick={() => {
            setOpenImportDialog(true);
          }}
          disabled={isDisabled}
        >
          Import
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={addNewResponsibility}
          startIcon={<AddIcon />}
          disabled={isDisabled}
        >
          New Responsibility
        </Button>
      </PageButtonGroup>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No.</TableCell>
              <TableCell>ID</TableCell>
              <TableCell style={{ minWidth: 100 }}>Company</TableCell>

              {filters['Template.EqualsTo'] === 'MARKETING' && (
                <>
                  <TableCell style={{ minWidth: 150 }}>Program</TableCell>
                  <TableCell style={{ minWidth: 150 }}>Category</TableCell>
                  <TableCell>Priority</TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell>Sales</TableCell>
                  <TableCell>SSO</TableCell>
                  <TableCell>CS</TableCell>
                  <TableCell>NPD HL</TableCell>
                  <TableCell>NPD PL</TableCell>
                  <TableCell>NPD NL</TableCell>
                  <TableCell>NPD TL</TableCell>
                  <TableCell>NPD WL</TableCell>
                  <TableCell>NPD Flexible</TableCell>
                  <TableCell>Entry</TableCell>
                </>
              )}

              {filters['Template.EqualsTo'] === 'QUOTATION' && (
                <>
                  <TableCell>Program</TableCell>
                  <TableCell>Quotation</TableCell>
                </>
              )}

              {filters['Template.EqualsTo'] === 'PLANNING' && (
                <>
                  <TableCell>Operation</TableCell>
                  <TableCell>Machines</TableCell>
                  <TableCell>Team</TableCell>
                  <TableCell>Planning</TableCell>
                </>
              )}

              {filters['Template.EqualsTo'] === 'ACCOUNT' && (
                <>
                  <TableCell>Program</TableCell>
                  <TableCell>Account</TableCell>
                </>
              )}

              {filters['Template.EqualsTo'] === 'INVOICE' && (
                <>
                  <TableCell>Program</TableCell>
                  <TableCell>Invoice</TableCell>
                </>
              )}

              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableLoading isLoading={loading} colSpan={30}>
              {responsibilities.map((responsibility, index) => {
                //#region set customers
                const customerNames =
                  responsibility?.responsibilityCustomers
                    ?.filter((rc) => rc.active === true)
                    ?.map((rc) => {
                      return rc.customer?.displayName || '';
                    }) || [];
                //#endregion

                const brandNames =
                  responsibility?.responsibilityBrands
                    ?.filter((rb) => rb.active === true)
                    ?.map((rb) => {
                      return rb.brand?.name || '';
                    }) || [];

                //#region set sales
                const salesNames =
                  responsibility?.responsibilitySalesTeamMembers
                    ?.filter((rs) => rs.active === true)
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status =
                        rs.status === 'P'
                          ? 'Sales'
                          : `Sales${rs.status?.replace('S', '')}`;

                      return {
                        name: rs.salesTeamMember?.user?.activated
                          ? `${rs.salesTeamMember?.user?.firstName} (${status})`
                          : `${rs.salesTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.salesTeamMember?.user?.activated,
                        userLeaveTotalDay: rs.salesTeamMember?.user?.userLeaveTotalDay,
                      };
                    }) || [];
                //#endregion

                //#region set cs
                const csNames =
                  responsibility?.responsibilityWorkingTeamMembers
                    ?.filter(
                      (rc) =>
                        rc.active === true &&
                        rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                          ?.name === 'CS',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status = rs.status === 'P' ? 'CS' : `C${rs.status}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                      };
                    }) || [];
                //#endregion

                //#region set sso
                const ssoNames =
                  responsibility?.responsibilityWorkingTeamMembers
                    ?.filter(
                      (rc) =>
                        rc.active === true &&
                        rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                          ?.name === 'SSO',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status =
                        rs.status === 'P' ? 'SSO' : `SSO${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                      };
                      // return (
                      //   `${rs.smWorkingTeamMember?.user?.fullNameWithUserName} (${status})` ||
                      //   ''
                      // );
                    }) || [];
                //#endregion

                //#region set entry
                const entryNames =
                  responsibility?.responsibilityWorkingTeamMembers
                    ?.filter(
                      (rc) =>
                        rc.active === true &&
                        rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                          ?.name === 'ENTRY',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status =
                        rs.status === 'P'
                          ? 'ENTRY'
                          : `ENTRY${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                      };
                    }) || [];
                //#endregion

                //#region set qn
                const qnNames =
                  responsibility?.responsibilityWorkingTeamMembers
                    ?.filter(
                      (rc) =>
                        rc.active === true &&
                        rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                          ?.name === 'QUOTATION',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status =
                        rs.status === 'P' ? 'QN' : `QN${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                      };
                    }) || [];
                //#endregion

                //#region set planning
                let planTeamName = '';
                const planNames =
                  responsibility?.responsibilityWorkingTeamMembers
                    ?.filter(
                      (rc) =>
                        rc.active === true &&
                        rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                          ?.name === 'PLANNING',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status =
                        rs.status === 'P' ? 'PLAN' : `PLAN${rs.status?.replace('S', '')}`;
                      if (rs.status === 'P') {
                        planTeamName = rs.smWorkingTeamMember?.smWorkingTeam?.name ?? '';
                      }

                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                      };
                    }) || [];
                //#endregion

                //#region set account
                const accountNames =
                  responsibility?.responsibilityWorkingTeamMembers
                    ?.filter(
                      (rc) =>
                        rc.active === true &&
                        rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                          ?.name === 'ACCOUNT',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status =
                        rs.status === 'P'
                          ? 'ACCOUNT'
                          : `ACCOUNT${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                      };
                    }) || [];
                //#endregion

                //#region set invoice
                const invoiceNames =
                  responsibility?.responsibilityWorkingTeamMembers
                    ?.filter(
                      (rc) =>
                        rc.active === true &&
                        rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                          ?.name === 'INVOICE',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    ?.map((rs) => {
                      const status =
                        rs.status === 'P'
                          ? 'LOGISTIC'
                          : `LOGISTIC${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status}) (Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                      };
                    }) || [];
                //#endregion

                const npdNames = responsibility?.responsibilityWorkingTeamMembers
                  ?.filter(
                    (rc) =>
                      rc.active === true &&
                      rc.smWorkingTeamMember?.smWorkingTeam?.smWorkingGroup?.role
                        ?.name === 'NPD',
                  )
                  .sort(
                    (a, b) =>
                      a.smWorkingTeamMember?.smWorkingTeam?.description?.localeCompare(
                        b.smWorkingTeamMember?.smWorkingTeam?.description || '',
                      ) || 0,
                  );

                //#region set npd HL
                const npdHlUsers =
                  npdNames
                    ?.filter(
                      (f) => f.smWorkingTeamMember?.smWorkingTeam?.description === 'HL',
                    )
                    .map((rs) => {
                      const npdType = rs.smWorkingTeamMember?.smWorkingTeam?.description;
                      const status =
                        rs.status === 'P' ? 'NPD' : `NPD${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status})(Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                        npdType,
                      };
                    }) || [];
                //#endregion

                //#region set npd PL
                const npdPlUsers =
                  npdNames
                    ?.filter(
                      (f) => f.smWorkingTeamMember?.smWorkingTeam?.description === 'PL',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    .map((rs) => {
                      const npdType = rs.smWorkingTeamMember?.smWorkingTeam?.description;
                      const status =
                        rs.status === 'P' ? 'NPD' : `NPD${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status})(Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                        npdType,
                      };
                    }) || [];
                //#endregion

                //#region set npd NL
                const npdNlUsers =
                  npdNames
                    ?.filter(
                      (f) => f.smWorkingTeamMember?.smWorkingTeam?.description === 'NL',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    .map((rs) => {
                      const npdType = rs.smWorkingTeamMember?.smWorkingTeam?.description;
                      const status =
                        rs.status === 'P' ? 'NPD' : `NPD${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status})(Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                        npdType,
                      };
                    }) || [];
                //#endregion

                //#region set npd TL
                const npdTlUsers =
                  npdNames
                    ?.filter(
                      (f) => f.smWorkingTeamMember?.smWorkingTeam?.description === 'TL',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    .map((rs) => {
                      const npdType = rs.smWorkingTeamMember?.smWorkingTeam?.description;
                      const status =
                        rs.status === 'P' ? 'NPD' : `NPD${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status})(Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                        npdType,
                      };
                    }) || [];
                //#endregion

                //#region set npd WL
                const npdWlUsers =
                  npdNames
                    ?.filter(
                      (f) => f.smWorkingTeamMember?.smWorkingTeam?.description === 'WL',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    .map((rs) => {
                      const npdType = rs.smWorkingTeamMember?.smWorkingTeam?.description;
                      const status =
                        rs.status === 'P' ? 'NPD' : `NPD${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status})(Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                        npdType,
                      };
                    }) || [];
                //#endregion

                //#region set npd Flexible
                const npdFlexibleUsers =
                  npdNames
                    ?.filter(
                      (f) =>
                        f.smWorkingTeamMember?.smWorkingTeam?.description === 'FLEXIBLE',
                    )
                    .sort((a, b) => a.status?.localeCompare(b.status || '') || 0)
                    .map((rs) => {
                      const npdType = rs.smWorkingTeamMember?.smWorkingTeam?.description;
                      const status =
                        rs.status === 'P' ? 'NPD' : `NPD${rs.status?.replace('S', '')}`;
                      return {
                        name: rs.smWorkingTeamMember?.user?.activated
                          ? `${rs.smWorkingTeamMember?.user?.firstName} (${status})`
                          : `${rs.smWorkingTeamMember?.user?.firstName} (${status})(Inactive)`,
                        activated: rs.smWorkingTeamMember?.user?.activated,
                        userLeaveTotalDay:
                          rs.smWorkingTeamMember?.user?.userLeaveTotalDay,
                        npdType,
                      };
                    }) || [];
                //#endregion

                return (
                  <TableRow key={responsibility.id}>
                    <TableCell>
                      {index + paging.pageSize * paging.pageNumber + 1}
                    </TableCell>
                    <TableCell>{responsibility?.id}</TableCell>
                    <TableCell>{responsibility?.company?.name}</TableCell>
                    <TableCell>{responsibility?.program?.name}</TableCell>
                    <TableCell>{responsibility.program?.typeOfBusiness}</TableCell>
                    {filters['Template.EqualsTo'] === 'MARKETING' && (
                      <>
                        <TableCell>
                          <Tooltip
                            title={
                              responsibility?.program?.isHighPriority
                                ? 'High Priority'
                                : 'Low Priority'
                            }
                          >
                            <Checkbox
                              color="secondary"
                              checked={responsibility?.program?.isHighPriority}
                            ></Checkbox>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <ChipList list={customerNames} />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={salesNames} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={ssoNames} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={csNames} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={npdHlUsers} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={npdPlUsers} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={npdNlUsers} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={npdTlUsers} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={npdWlUsers} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={npdFlexibleUsers} noAllLabel />
                        </TableCell>
                        <TableCell>
                          <ChipListUser list={entryNames} noAllLabel />
                        </TableCell>
                      </>
                    )}

                    {filters['Template.EqualsTo'] === 'QUOTATION' && (
                      <TableCell>
                        <ChipListUser list={qnNames} noAllLabel />
                      </TableCell>
                    )}

                    {filters['Template.EqualsTo'] === 'PLANNING' && (
                      <>
                        <TableCell>
                          {brandNames.length > 0 ? brandNames.join(', ') : 'ALL'}
                        </TableCell>
                        <TableCell>{planTeamName}</TableCell>

                        <TableCell>
                          <ChipListUser list={planNames} noAllLabel />
                        </TableCell>
                      </>
                    )}

                    {filters['Template.EqualsTo'] === 'ACCOUNT' && (
                      <TableCell>
                        <ChipListUser list={accountNames} noAllLabel />
                      </TableCell>
                    )}

                    {filters['Template.EqualsTo'] === 'INVOICE' && (
                      <TableCell>
                        <ChipListUser list={invoiceNames} noAllLabel />
                      </TableCell>
                    )}

                    {/* <TableCell>
                    <ChipList list={brandNames} />
                  </TableCell> */}

                    {/* <TableCell>{responsibility?.createdBy}</TableCell> */}
                    <TableCell>
                      <div>
                        {
                          ResponsibilityStatusIcon[
                            ResponsibilityStatusLabel[responsibility.status!]
                          ]
                        }
                      </div>
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Edit">
                        <span>
                          <IconButton
                            size="small"
                            onClick={() => {
                              editResponsibility(responsibility.id!);
                            }}
                            disabled={isDisabled}
                          >
                            <EditIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableLoading>
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[...TablePageSize]}
        component="div"
        count={totalItems}
        rowsPerPage={paging.pageSize}
        page={paging.pageNumber}
        onPageChange={handleChangePageNumber}
        onRowsPerPageChange={handleChangePageSize}
      />
      <ResponsibilityImportDialog
        open={openImportDialog}
        onClose={() => setOpenImportDialog(false)}
      />
    </PageContainer>
  );
};

export default ResponsibilityList;
